export default "__VITE_ASSET__BtZc1q36__"